







































import {Vue, Component} from 'vue-property-decorator';
import {addClass, removeClass} from '@/utils/classUtils';
@Component
export default class DeliveryAmtDetail extends Vue {
  private orderInfo: any = {
    baseDeliveryAmt: 0,
    areaDeliveryAmt: 0,
    totalDeliveryAmt: 0
  };
  private isLast: boolean = false;
  private created(): void {
    this.checkFirstOrLast();
  }
  private beforeDestroy(): void {
    removeClass(document.body, 'popup popup_small');
  }

  private checkFirstOrLast(): void {
    this.isLast = this.$route.path === '/delivery/last-amt-detail';
  }
  private getOrderInfo(): void {
    let orderRequest: any = {
      params: {
        orderNo: this.$route.query.orderNo as any
      }
    };
    this.$api.getOrdersByOrderNo(orderRequest).then((res: any): any => {
      let order: any = res.data;
      let baseDeliveryAmt = 0;
      let areaDeliveryAmt = 0;
      let totalDeliveryAmt = order.lastBalance.deliveryAmt + order.lastBalance.remoteDeliveryAmt - order.lastBalance.deliveryCouponDiscountAmt
      order.shippings.map((item: any): any => {
        if(item.prepaid === false) {
          baseDeliveryAmt += 0;
          areaDeliveryAmt += 0;
        } else {
          baseDeliveryAmt += Number(item.adjustedDeliveryAmt);
          areaDeliveryAmt += Number(item.adjustedRemoteDeliveryAmt);
        }
      });
      if(this.isLast) {
        this.orderInfo = {
          baseDeliveryAmt: baseDeliveryAmt.toLocaleString(),
          areaDeliveryAmt: areaDeliveryAmt.toLocaleString(),
          totalDeliveryAmt: totalDeliveryAmt.toLocaleString(),
          returnExchangesDeliveryAmt: (totalDeliveryAmt - areaDeliveryAmt - baseDeliveryAmt).toLocaleString()
        };
      } else {
        this.orderInfo = {
          baseDeliveryAmt: order.firstBalance.deliveryAmt.toLocaleString(),
          areaDeliveryAmt: order.firstBalance.remoteDeliveryAmt.toLocaleString(),
          totalDeliveryAmt: (order.firstBalance.deliveryAmt + order.firstBalance.remoteDeliveryAmt - order.firstBalance.deliveryCouponDiscountAmt).toLocaleString()
        };
      }

    });
  }

  public popupResize(): void {
    let contentWidth = $('#container').width() + 30;
    let contentHeight = $('#container').height() + 76;
    window.resizeTo(contentWidth, contentHeight);
  }

  public mounted() {
    addClass(document.body, 'popup popup_small');
    this.getOrderInfo();
    setTimeout(() => {this.popupResize()},1000)
  }
}
